import usePaginatedFetch from "../core/usePaginatedFetch";

export const useTokenPriceHistory = (tokenId, params) =>
  usePaginatedFetch(`/tokens/${ tokenId }/price-history`, { ...params });

export const useTokenTrades = (tokenId, limit = 10) =>
  usePaginatedFetch(`/tokens/${ tokenId }/trades`, { limit });

export const useGetTokenCreator = (tokenId) =>
  usePaginatedFetch(`/tokens/${ tokenId }/creator`);

export const useGetTopTokens = (params) =>
  usePaginatedFetch("/tokens/top-tokens", { ...params });

export const useGetRugAnalytics = (tokenId) => usePaginatedFetch(`/tokens/${ tokenId }/rug-analytics`);